import React from 'react'
import Column from '@amzn/meridian/column'
import Text from '@amzn/meridian/text'
import { ToggleSetting } from './components'
import { INotificationPreferences } from './services/PreferencesService'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

interface IPushNotificationSettingsProps {
    preferences: INotificationPreferences
    onUpdate: (updates: Partial<INotificationPreferences>) => void
}

/**
 * Push Notification Settings sub-page (Figma Screen 33).
 * Single toggle: "Allow app notifications to this device"
 */
export const PushNotificationSettings: React.FC<IPushNotificationSettingsProps> = ({
    preferences,
    onUpdate,
}) => {
    const [bundle] = useBundle(BUNDLE_NAME)
    return (
        <Column spacing="400" spacingInset="400">
            <Text type="h300">{t(bundle, 'jsma-web-profile-pushNotificationsTitle')}</Text>
            <ToggleSetting
                label={t(bundle, 'jsma-web-profile-pushToggleLabel')}
                description={t(bundle, 'jsma-web-profile-pushToggleDesc')}
                checked={preferences.pushEnabled}
                onChange={(checked) => onUpdate({ pushEnabled: checked })}
                testId="push-notification-toggle"
            />
        </Column>
    )
}
